import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { Link } from 'gatsby';
import { FluidObject } from 'gatsby-image';
import BackgroundImage from 'gatsby-background-image';
import DefaultTitle from '../../components/DefaultTitle';


const ShadowContainer = styled.div`
  box-shadow: 4px 4px 11px rgba(0, 0, 0, 0.2);
  margin: 10px;
`;

const Container = styled(BackgroundImage)`
  margin: 0;
  position: relative;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 160px;
  height: 160px;
  padding: 20px;
  cursor: pointer;
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    width: 250px;
    height: 250px;
    padding: 30px;
  }
  &:hover {
    padding: 0;
  }
  transition: padding 200ms ease-in-out;
`;

const InnerContainer = styled.div`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.colors.grayWithOpacity};
  padding: 8px; 
  mix-blend-mode: multiply;

  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    font-size: ${({ theme }) => theme.headingSize.medium};
  }
  transition: background 200ms ease-in-out;
  &:hover {
    background: ${({ theme }) => theme.colors.gray} ;
  }
`;

const Title = styled(DefaultTitle)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
`;

interface TileProps{
  fluid: FluidObject,
  text?: string,
  to: string,
}

const Tile = ({ fluid, text, to }: TileProps) => {
  const theme = useContext(ThemeContext);
  return (
    <Link to={to}>
      <ShadowContainer>
        <Container fluid={fluid}>
          {text && (
            <>
              <InnerContainer />
              <Title color={theme.colors.white}>
                {text}
              </Title>
            </>
          )}
        </Container>
      </ShadowContainer>
    </Link>
  );
};
export default Tile;
